import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import '../styles.css';


const Checkbox = ({ checkboxContainerClass, checkmarkClass, ...props }) => {
    return (
        <>
            <label className={checkboxContainerClass}>
                <input type="checkbox"  {...props} />
                <span className={checkmarkClass}>
                    {props.checked && <FontAwesomeIcon icon={faCheck} />}
                </span>
            </label>
        </>
    )
}


export default Checkbox;